import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/upload-instructions/shield.png'


const _withScopeId = n => (_pushScopeId("data-v-62ba3196"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row content-wrapper security-popup" }
const _hoisted_2 = { class: "security-popup__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "security-popup__image",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "row row--navigation-btn d-flex justify-center security-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.dataSecurityHeader`)), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.dataSecurityText`)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", {
        class: "button button-biger button--submit security-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClosePopup && _ctx.handleClosePopup(...args)))
      }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.close`)), 1)
    ])
  ]))
}